import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import { Grid, Paper, Typography } from "@material-ui/core";
import { Dashboard as DashboardLayout } from "layouts";
import styles from "theme/skin";
import { withRouter } from "react-router";
import compose from "recompose/compose";
import EditSalesRep from "./EditSalesRep";

function MySalesEditRep(props) {
  const { classes } = props;
  return (
    <DashboardLayout title="Edit Dealer">
      <div className={classes.root + " sectionContainer"}>
        <Typography gutterBottom variant="h4" className="title">
          <span>Edit Sales Rep</span>
        </Typography>

        <Paper className={classes.paper} style={{ margin: "2em 3em" }}>
          <Grid container>
            <Grid item xs align="center">
              <EditSalesRep />
            </Grid>
          </Grid>
        </Paper>
      </div>
    </DashboardLayout>
  );
}

MySalesEditRep.propTypes = {
  classes: PropTypes.object.isRequired
};

export default compose(withRouter, withStyles(styles))(MySalesEditRep);
